<template>
  <div class="microsites">
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar title="Microsites" hideSearchBar />
      <div v-if="isFetchingMicrosites">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="microsite in microsites"
          :key="microsite.id"
          @click="handleView(microsite)"
        >
          <MicrositeItem :microsite="microsite" />
        </v-list-item>
      </div>
      <BaseFooter>
        <Permissioned section="settings" class="d-flex actions-bar">
          <NewMicrositeAction permissions="microsites.edit" />
        </Permissioned>
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { MICROSITE_NAMESPACE } from "@/store/modules/microsites";
import { FETCH_MICROSITES } from "@/store/modules/microsites/actions";
import { copyState } from "@/utils/helpers";
import MicrositeItem from "@/views/settings/components/microsites/components/MicrositeItem";
import BaseFooter from "@/components/common/BaseFooter";
import NewMicrositeAction from "@/views/settings/components/microsites/components/actions/NewMicrositeAction";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { size } from "lodash";
import Permissioned from "@/components/common/Permissioned";

const { mapActions, mapState } = createNamespacedHelpers(MICROSITE_NAMESPACE);

export default {
  components: {
    MicrositeItem,
    BaseFooter,
    NewMicrositeAction,
    BaseListToolbar,
    Permissioned
  },
  created() {
    this.fetchMicrosites(this.requestParams);
  },
  data() {
    return {
      searchText: ""
    };
  },
  computed: {
    ...mapState(copyState(["microsites", "isFetchingMicrosites"])),
    requestParams() {
      return {
        filter: {
          ...(size(this.searchText) && { search: this.searchText })
        }
      };
    }
  },
  methods: {
    ...mapActions({
      fetchMicrosites: FETCH_MICROSITES
    }),
    handleView({ id }) {
      this.$router.push({
        name: "micrositeDetails",
        params: { id }
      });
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.fetchMicrosites(this.requestParams);
    }
  }
};
</script>

<style lang="scss"></style>
